import React, { useState, useEffect } from "react";
import { InfoElementWrapper, ProgramInfoWrapper } from "./style";
import { useMediaQuery } from "@react-hook/media-query";
import {
	Text,
	Grid,
	Col,
	Separator,
	Icon,
} from "@website-builder/ui/shared/elements";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import { isDateValid } from "@website-builder/utilities/utils/utils.js";
import {
	formatDate,
	isBusinessVerticalB2U,
} from "@website-builder/utilities/utils/helpers.js";
const isB2U = isBusinessVerticalB2U();
const ProgramInfo = (props) => {
	const TO_BE_ANNOUNCED = "To be announced";
	const {
		applyByHeader,
		sectionDetails,
		applyByIcon,
		fetchApiUrl,
		topMargin,
		cardBackgroundColor,
		darkBg,
		hasBoxShadow,
	} = props;
	const [programInfoDetails, setProgramInfoDetails] = useState({});
	useEffect(() => {
		const abortController = new AbortController();
		const fetchCourseDetails = async () => {
			try {
				const response = await fetch(fetchApiUrl, {
					signal: abortController?.signal,
				}).then((res) => res.json());
				const { application_deadline, next_date_string } = response || {};

				// In case of invalid response:  show the message 'To be announced'
				// Convert enrollment_closes_days & enrollment_closes_hours to string values so that they can be checked for non null values in the render function
				// 0 => false but "0" is true
				const data = {
					nextDateString: isDateValid(next_date_string) ? next_date_string : "",
					applicationDeadline: isDateValid(application_deadline)
						? formatDate(application_deadline, "MMM d, y")
						: "",
					error: false,
				};
				setProgramInfoDetails(data);
			} catch (err) {
				if (err.name === "AbortError") {
					// The fetch was aborted, no need to handle this error
					return;
				}
				console.log("err", err);
				setProgramInfoDetails({
					nextDateString: "",
					applicationDeadline: "",
				});
			}
		};
		fetchCourseDetails();

		return () => {
			// Cleanup: Abort the fetch request if the component unmounts
			abortController?.abort?.();
		};
	}, []);
	const satisfiesMobileWidth = useMediaQuery(`(max-width: ${TABLET_M_BP}px)`);
	const [isMobile, setIsMobile] = useState(false);
	useEffect(() => {
		setIsMobile(satisfiesMobileWidth);
	}, [satisfiesMobileWidth]);
	const { nextDateString = "", applicationDeadline: cohortCutOffDate = "" } =
		programInfoDetails || {};
	return (
		<ProgramInfoWrapper
			hasBoxShadow={hasBoxShadow}
			className="program-info"
			icon={applyByIcon && applyByIcon?.[0]?.iconName}
			topMargin={topMargin}
			backgroundColor={cardBackgroundColor?.color}
			darkBg={darkBg}
		>
			<Grid className="program-info-grid">
				{sectionDetails?.map?.(
					({ description, subCopy, icon = {}, title }, index) => (
						<>
							<InfoElement
								key={title}
								icon={icon?.[0]}
								title={title}
								value={description}
								subContent={subCopy}
								start={(index + 1) * 2 - 1}
								span={1}
							/>
							{!isMobile ? (
								<Col
									className="separator-wrapper"
									start={(index + 1) * 2}
									span={1}
								>
									<Separator
										vertical={!isMobile}
										className="vertical-seperator"
										color={
											darkBg
												? "var(--secondary-gray-medium)"
												: "rgba(0,0,0,0.3)"
										}
									/>
								</Col>
							) : null}
						</>
					),
				)}
				<InfoElement
					icon={applyByIcon?.[0]}
					title={applyByHeader}
					value={cohortCutOffDate ? cohortCutOffDate : TO_BE_ANNOUNCED}
					subContent={nextDateString ? `Cohort starts ${nextDateString}` : ""}
					start={5}
					span={1}
				/>
			</Grid>
		</ProgramInfoWrapper>
	);
};

export default ProgramInfo;

const InfoElement = (infoDetails) => {
	const { icon, title, value, subContent, start, span } = infoDetails;
	const { iconName, size, fill, stroke } = icon || {};
	return (
		<Col
			className="col-wrapper"
			start={start}
			span={span}
			mdStart={1}
			mdSpan={6}
		>
			<InfoElementWrapper isSeparator>
				{iconName ? (
					<Icon
						className="info-icon"
						iconName={iconName}
						size={isB2U ? `${size}px` : "32px"}
						stroke={stroke?.color}
						fill={fill?.color}
						strokeWidth="1"
					/>
				) : null}
				<div className={`content-wrapper`}>
					<Text variant={icon ? "paragraph_S" : "paragraph_L"}>{title}</Text>
					<Text variant={icon ? "paragraph_L" : "headline_6"} tag="p">
						{value}
					</Text>
					<Text variant={icon ? "paragraph_S" : "paragraph_M"}>
						{subContent}
					</Text>
				</div>
			</InfoElementWrapper>
		</Col>
	);
};
